export const TOGGLE_THEME = "TOGGLE_THEME";
export const LOADING = "LOADING";
export const SET_LOADING = "SET_LOADING";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const SHOW_SNACKBAR_INDEEP = "SHOW_SNACKBAR_INDEEP";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";
export const INITIALLY_RENDERED = "INITIALLY_RENDERED";
export const SHOW_MODAL = "SHOW_MODAL";
